import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';


Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  boldText: {
    fontFamily: 'Roboto',
    fontWeight: 'ultrabold'
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  columnHeader: {
    width: '10%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '12%',
    padding: 3,
    textAlign: 'center',
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};
const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const CreditPdfReport = ({ data }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Credit Register Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <View style={styles.row}>
              <Text style={{...styles.columnHeader, width:'10%'}} content="Sr No." />
              <Text style={{...styles.columnHeader, width:'10%'}} content=" Bill Date" />
              <Text style={{...styles.columnHeader,width:"10%"}} content="Bill No." />
              <Text style={{ ...styles.columnHeader, width: '20%' }} content="UHID/ADM No" />
              <Text style={{...styles.columnHeader,width:"25%"}} content="Patient Name" />
              <Text style={{...styles.columnHeader,width:"10%"}} content="Amount" />
              <Text style={{ ...styles.columnHeader, width: '10%' }} content="Paymode" />                                                                                          
              <Text style={{...styles.columnHeader, width: '15%'}} content="Remarks" />
            </View>
            {data &&
              data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{...styles.columnContent, width:'10%'}} content={index + 1} />
                  <Text style={{...styles.columnContent,width:"10%"}} content={formatDate(data?.date)} />
                  <Text style={{...styles.columnContent, textAlign:'left',width:"10%"}} content={data?.inv_no} />
                  <Text style={{ ...styles.columnContent, width: '20%', textAlign:'left' }}
                    content={`${data?.uhid}/${data?.ipd_no}`} />
                  <Text style={{...styles.columnContent,width:"25%"}} content={data?.patientName} />
                  <Text style={{...styles.columnContent, textAlign:'left',width:"10%"}} content={data?.bill_amount} />
                   <Text style={{...styles.columnContent, textAlign:'left',width:"10%"}} content={data?.pay_mode} />
                  <Text style={{ ...styles.columnContent, width: '15%', textAlign:'left' }} content={data?.remarks} />
                </View>
              ))}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};


